import { SeasonStatus } from './../enums/status';
import { SalaryRangeItem } from './salary';
import { User } from './user';

export interface Season {
    id: string;
    title: string;
    createdAt?: Date;
    updatedAt?: Date;
    updatedBy?: string;
    startDate?: Date;
    endDate?: Date;
    totalBudget?: number;
    totalPayout?: number;
    applicationDeadline?: Date;
    status: SeasonStatus;
    payoutElements: PayoutElement[];
    salaryRangeItems: SalaryRangeItem[];
    eligibilityCriteria: EligibilityCriterion[];
}

export interface SeasonWithUpdateBy {
    id: string;
    title: string;
    createdAt?: Date;
    updatedAt?: Date;
    updatedBy?: User;
    startDate?: Date;
    endDate?: Date;
    totalBudget?: number;
    totalPayout?: number;
    applicationDeadline?: Date;
    status: SeasonStatus;
    payoutElements: PayoutElement[];
    salaryRangeItems: SalaryRangeItem[];
    eligibilityCriteria: EligibilityCriterion[];
}

export interface PayoutElement {
    id: string;
    name: string;
    minimumDuration: number; //days
    maximumDuration?: number; //days
    amount: number;
}

export interface EligibilityCriterion {
    id: string;
    property: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value?: any;
    comparisonOperator: ComparisonOperator;
    weight: number;
    joinedEntityName?: string;
}

export interface AutoSelectApplications {
    applicationCutOffDate: Date;
    percentage: number;
}

export enum ComparisonOperator {
    EQUALS = 'EQUALS',
    IS_GREATER_THAN = 'IS_GREATER_THAN',
    IS_LESS_THAN = 'IS_LESS_THAN',
    BETWEEN = 'BETWEEN',
    EXISTS = 'EXISTS'
}
